import hasItems from '../has-items'
import MessageError from '../../topics/Error/screens/MessageError'
import translate from '../translate'
import ErrorBoundary from '../../topics/Error/widgets/ErrorBoundary'
import Block from '../../layouts/Blocks'
import React from 'react'
import pick from 'lodash/pick'

const getData = ({ dataIds, data, noArticles }) => {
  if (dataIds.length === 1 && noArticles) return data[dataIds[0]]
  if (dataIds.length > 0) return pick(data, dataIds)
}

const getArticles = ({ articleIds, articles }) => {
  return articleIds.map((id) => {
    if (hasItems(articles[id])) {
      articles[id].position = id
      return articles[id]
    } else {
      throw new Error(translate('dev_errorlog_few_articles', { id }))
    }
  })
}

const LayoutBuilder = ({ layout, data, ...props }) => {
  if (!data) return false
  return layout.map(({ name, adIds, dataIds, articleIds, margin }, index) => {
    try {
      let blockData = []
      if (dataIds) blockData = getData({ dataIds, data, noArticles: !hasItems(articleIds) })
      if (articleIds) blockData['articles'] = getArticles({ articleIds, articles: data.articles })

      const errorOptions = {
        logError: translate('dev_errorlog_home_block', { name: name }),
      }
      return (
        <ErrorBoundary key={'Errorboundary' + name + index} {...errorOptions}>
          <Block view={name} key={'Home' + name + index} adIds={adIds} data={blockData} margin={margin} {...props} />
        </ErrorBoundary>
      )
    } catch (error) {
      return <MessageError key={'Error ' + name + index} logError={'home screen' + name} logInfo={error.message} />
    }
  })
}

export default LayoutBuilder
